import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  LoadFarm,
  LoadDiaryList,
  TargetDiaryAct,
  GetWeather,
  GetWeathertemp,
  Getenvirdata,
  Getenvirdata2,
  Getenvirdata3,
  Getenvirdata4,
  CreateCounsel,
  LoadCounsel,
  LoadDetailCounsel,
  LoadmultidiaryList,
} from "../reduxaction/post";

import {
  Farmstype,
  DiaryListtype,
  TargetDiarytype,
  GetWeathertype,
  GetWeathertemptype,
  Getenvirdatatype,
  Getenvirdatatype2,
  Getenvirdatatype3,
  Getenvirdatatype4,
  resulttype,
  ProductCategorytype,
  DiaryClasstype,
  LoadCounseltype,
  LoadDetailCounseltype,
} from "./postpayloadtypes";

interface InitialState {
  Farms: Farmstype[];
  LoadfarmsLoading: boolean;
  LoadfarmsDone: boolean;
  LoadfarmsError: string | null;

  Targetfarms: Farmstype | null;

  TargetfarmsLoading: boolean;
  TargetfarmsDone: boolean;
  TargetfarmsError: string | null;

  Diarylist: resulttype[];

  DiarylistLoading: boolean;
  DiarylistDone: boolean;
  DiarylistError: string | null;

  TargetDiary: TargetDiarytype | null;
  TargetDiaryLoading: boolean;
  TargetDiaryDone: boolean;
  TargetDiaryError: string | null;

  TargetInsectContainer: string | null;

  Weather: GetWeathertype[];
  WeatherLoading: boolean;
  WeatherDone: boolean;
  WeatherError: string | null;

  Weathertemp: GetWeathertemptype | null;
  WeathertempLoading: boolean;
  WeathertempDone: boolean;
  WeathertempError: string | null;

  envirdata: Getenvirdatatype[];
  envirdataLoading: boolean;
  envirdataDone: boolean;
  envirdataError: string | null;

  envirdata2: Getenvirdatatype2[];
  envirdataLoading2: boolean;
  envirdataDone2: boolean;
  envirdataError2: string | null;

  envirdata3: Getenvirdatatype3[];
  envirdataLoading3: boolean;
  envirdataDone3: boolean;
  envirdataError3: string | null;

  envirdata4: Getenvirdatatype4[];
  envirdataLoading4: boolean;
  envirdataDone4: boolean;
  envirdataError4: string | null;

  productcode: ProductCategorytype[];

  diarytype: DiaryClasstype[];

  // ----- 상담일지
  CreateCouncelLoading: boolean;
  CreateCouncelDone: boolean;
  CreateCouncelError: null;

  LoadCounselListLoading: boolean;
  LoadCounselListDone: boolean;
  LoadCounselListError: null;
  CounselListList: LoadCounseltype[];

  DetailCounselLoading: boolean;
  DetailCounselDone: boolean;
  DetailCounselError: null;
  DetailCounsel: LoadDetailCounseltype | null;

  MultiDiarylist: resulttype[];

  MultiDiarylistLoading: boolean;
  MultiDiarylistDone: boolean;
  MultiDiarylistError: string | null;
}

const initialState: InitialState = {
  Farms: [],
  LoadfarmsLoading: false,
  LoadfarmsDone: false,
  LoadfarmsError: null,

  Targetfarms: null,

  TargetfarmsLoading: false,
  TargetfarmsDone: false,
  TargetfarmsError: null,

  Diarylist: [],

  DiarylistLoading: false,
  DiarylistDone: false,
  DiarylistError: null,

  TargetDiary: null,
  TargetDiaryLoading: false,
  TargetDiaryDone: false,
  TargetDiaryError: null,

  TargetInsectContainer: null, // 일지 작성 컨테이너 선택 값

  Weather: [],
  WeatherLoading: false,
  WeatherDone: false,
  WeatherError: null,

  Weathertemp: null,
  WeathertempLoading: false,
  WeathertempDone: false,
  WeathertempError: null,

  envirdata: [],
  envirdataLoading: false,
  envirdataDone: false,
  envirdataError: null,

  envirdata2: [],
  envirdataLoading2: false,
  envirdataDone2: false,
  envirdataError2: null,

  envirdata3: [],
  envirdataLoading3: false,
  envirdataDone3: false,
  envirdataError3: null,

  envirdata4: [],
  envirdataLoading4: false,
  envirdataDone4: false,
  envirdataError4: null,

  productcode: [],

  diarytype: [],

  // ---- 상담일지

  CreateCouncelLoading: false,
  CreateCouncelDone: false,
  CreateCouncelError: null,

  LoadCounselListLoading: false,
  LoadCounselListDone: false,
  LoadCounselListError: null,
  CounselListList: [],

  DetailCounselLoading: false,
  DetailCounselDone: false,
  DetailCounselError: null,
  DetailCounsel: null,

  // 다중선택 diary

  MultiDiarylist: [],

  MultiDiarylistLoading: false,
  MultiDiarylistDone: false,
  MultiDiarylistError: null,
};

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {
    // targetLoadFarm
    targetFarm(state, action: PayloadAction<Farmstype>) {
      state.Targetfarms = action.payload;
      state.TargetfarmsLoading = false;
      state.TargetfarmsDone = true;
    },
    refreshDiaryList(state) {
      state.Diarylist = [];
    },

    refreshMultiDiarylist(state) {
      state.MultiDiarylist = [];
    },
    TargetInsectContainer(state, action: PayloadAction<string>) {
      state.TargetInsectContainer = action.payload;
    },

    refreshCounselListList(state) {
      state.CounselListList = [];
    },
    productcode(state, action: PayloadAction<ProductCategorytype[]>) {
      state.productcode = action.payload;
    },

    diarytype(state, action: PayloadAction<DiaryClasstype[]>) {
      state.diarytype = action.payload;
    },

    refreshDetailCounsel(state, action: any) {
      state.DetailCounsel = null;
    },
  },
  extraReducers: (builder) =>
    builder
      // LoadFarm
      .addCase(LoadFarm.pending, (state) => {
        state.LoadfarmsLoading = true;
        state.LoadfarmsDone = false;
        state.LoadfarmsError = null;
      })
      .addCase(
        LoadFarm.fulfilled,
        (state, action: PayloadAction<Farmstype[]>) => {
          state.LoadfarmsLoading = false;
          state.Farms = action.payload;
          state.LoadfarmsDone = true;
        }
      )
      .addCase(LoadFarm.rejected, (state, action: any) => {
        state.LoadfarmsLoading = false;
        state.LoadfarmsError = action.payload.message;
      })
      // LoadDiaryList
      .addCase(LoadDiaryList.pending, (state) => {
        state.DiarylistLoading = true;
        state.DiarylistDone = false;
        state.DiarylistError = null;
      })
      .addCase(
        LoadDiaryList.fulfilled,
        (state, action: PayloadAction<resulttype[]>) => {
          state.DiarylistLoading = false;

          // state.Diarylist = state.Diarylist.concat(action.payload);
          const newDiaryEntries = action.payload.filter(
            (newEntry) =>
              !state.Diarylist.some(
                (existingEntry) => existingEntry.diaryId === newEntry.diaryId
              )
          );

          state.Diarylist = state.Diarylist.concat(newDiaryEntries);

          state.DiarylistDone = true;
        }
      )
      .addCase(LoadDiaryList.rejected, (state, action: any) => {
        state.DiarylistLoading = false;
        state.DiarylistError = action.payload.message;
      })

      // TargetDiary
      .addCase(TargetDiaryAct.pending, (state) => {
        state.TargetDiaryLoading = true;
        state.TargetDiaryDone = false;
        state.TargetDiaryError = null;
      })
      .addCase(
        TargetDiaryAct.fulfilled,
        (state, action: PayloadAction<TargetDiarytype>) => {
          state.TargetDiaryLoading = false;
          state.TargetDiary = action.payload;
          state.TargetDiaryDone = true;
        }
      )
      .addCase(TargetDiaryAct.rejected, (state, action: any) => {
        state.TargetDiaryLoading = false;
        state.TargetDiaryError = action.payload.message;
      })

      // GetWeather
      .addCase(GetWeather.pending, (state) => {
        state.WeatherLoading = true;
        state.WeatherDone = false;
        state.WeatherError = null;
      })
      .addCase(
        GetWeather.fulfilled,
        (state, action: PayloadAction<GetWeathertype[]>) => {
          state.WeatherLoading = false;
          state.Weather = action.payload;
          state.WeatherDone = true;
        }
      )
      .addCase(GetWeather.rejected, (state, action: any) => {
        state.WeatherLoading = false;
        state.WeatherError = action.payload.message;
      })

      // GetWeathertemp
      .addCase(GetWeathertemp.pending, (state) => {
        state.WeathertempLoading = true;
        state.WeathertempDone = false;
        state.WeathertempError = null;
      })
      .addCase(
        GetWeathertemp.fulfilled,
        (state, action: PayloadAction<GetWeathertemptype>) => {
          state.WeathertempLoading = false;
          state.Weathertemp = action.payload;
          state.WeathertempDone = true;
        }
      )
      .addCase(GetWeathertemp.rejected, (state, action: any) => {
        state.WeathertempLoading = false;
        state.WeathertempError = action.payload.message;
      })

      // Getenvirdata
      .addCase(Getenvirdata.pending, (state) => {
        state.envirdataLoading = true;
        state.envirdataDone = false;
        state.envirdataError = null;
      })
      .addCase(
        Getenvirdata.fulfilled,
        (state, action: PayloadAction<Getenvirdatatype[]>) => {
          state.envirdataLoading = false;
          state.envirdata = action.payload;
          state.envirdataDone = true;
        }
      )
      .addCase(Getenvirdata.rejected, (state, action: any) => {
        state.envirdataLoading = false;
        state.envirdataError = action.payload.message;
      })

      // Getenvirdata2
      .addCase(Getenvirdata2.pending, (state) => {
        state.envirdataLoading2 = true;
        state.envirdataDone2 = false;
        state.envirdataError2 = null;
      })
      .addCase(
        Getenvirdata2.fulfilled,
        (state, action: PayloadAction<Getenvirdatatype2[]>) => {
          state.envirdataLoading2 = false;
          state.envirdata2 = action.payload;
          state.envirdataDone2 = true;
        }
      )
      .addCase(Getenvirdata2.rejected, (state, action: any) => {
        state.envirdataLoading2 = false;
        state.envirdataError2 = action.payload.message;
      })

      // Getenvirdata3
      .addCase(Getenvirdata3.pending, (state) => {
        state.envirdataLoading3 = true;
        state.envirdataDone3 = false;
        state.envirdataError3 = null;
      })
      .addCase(
        Getenvirdata3.fulfilled,
        (state, action: PayloadAction<Getenvirdatatype3[]>) => {
          state.envirdataLoading3 = false;
          state.envirdata3 = action.payload;
          state.envirdataDone3 = true;
        }
      )
      .addCase(Getenvirdata3.rejected, (state, action: any) => {
        state.envirdataLoading3 = false;
        state.envirdataError3 = action.payload.message;
      })

      // Getenvirdata4
      .addCase(Getenvirdata4.pending, (state) => {
        state.envirdataLoading4 = true;
        state.envirdataDone4 = false;
        state.envirdataError4 = null;
      })
      .addCase(
        Getenvirdata4.fulfilled,
        (state, action: PayloadAction<Getenvirdatatype4[]>) => {
          state.envirdataLoading4 = false;
          state.envirdata4 = action.payload;
          state.envirdataDone4 = true;
        }
      )
      .addCase(Getenvirdata4.rejected, (state, action: any) => {
        state.envirdataLoading4 = false;
        state.envirdataError4 = action.payload.message;
      })

      // --------- 상담일지
      // CreateCounsel
      .addCase(CreateCounsel.pending, (state) => {
        state.CreateCouncelLoading = true;
        state.CreateCouncelDone = false;
        state.CreateCouncelError = null;
      })
      .addCase(CreateCounsel.fulfilled, (state, action: any) => {
        state.CreateCouncelLoading = false;
        state.CreateCouncelDone = true;
      })
      .addCase(CreateCounsel.rejected, (state, action: any) => {
        state.CreateCouncelLoading = false;
        state.CreateCouncelError = action.payload.message;
      })

      // LoadCounsel
      .addCase(LoadCounsel.pending, (state) => {
        state.LoadCounselListLoading = true;
        state.LoadCounselListDone = false;
        state.LoadCounselListError = null;
      })
      .addCase(
        LoadCounsel.fulfilled,
        (state, action: PayloadAction<LoadCounseltype[]>) => {
          state.LoadCounselListLoading = false;
          // state.CounselListList = action.payload;
          state.CounselListList = state.CounselListList.concat(action.payload);
          state.LoadCounselListDone = true;
        }
      )
      .addCase(LoadCounsel.rejected, (state, action: any) => {
        state.LoadCounselListLoading = false;
        state.LoadCounselListError = action.payload.message;
      })

      // LoadDetailCounsel
      .addCase(LoadDetailCounsel.pending, (state) => {
        state.DetailCounselLoading = true;
        state.DetailCounselDone = false;
        state.DetailCounselError = null;
      })
      .addCase(
        LoadDetailCounsel.fulfilled,
        (state, action: PayloadAction<LoadDetailCounseltype>) => {
          state.DetailCounselLoading = false;
          state.DetailCounsel = action.payload;
          state.DetailCounselDone = true;
        }
      )
      .addCase(LoadDetailCounsel.rejected, (state, action: any) => {
        state.DetailCounselLoading = false;
        state.DetailCounselError = action.payload.message;
      })

      //  LoadmultidiaryList
      .addCase(LoadmultidiaryList.pending, (state) => {
        state.MultiDiarylistLoading = true;
        state.MultiDiarylistDone = false;
        state.MultiDiarylistError = null;
      })
      .addCase(
        LoadmultidiaryList.fulfilled,
        (state, action: PayloadAction<resulttype[]>) => {
          state.MultiDiarylistLoading = false;
          state.MultiDiarylist = state.MultiDiarylist.concat(action.payload);

          state.MultiDiarylistDone = true;
        }
      )
      .addCase(LoadmultidiaryList.rejected, (state, action: any) => {
        state.MultiDiarylistLoading = false;
        state.MultiDiarylistError = action.payload.message;
      })
      .addDefaultCase((state) => state),
});

export default postSlice;
